import { render, staticRenderFns } from "./DisputeStatus.vue?vue&type=template&id=c145ea8e"
import script from "./DisputeStatus.vue?vue&type=script&lang=js"
export * from "./DisputeStatus.vue?vue&type=script&lang=js"
import style0 from "./DisputeStatus.vue?vue&type=style&index=0&id=c145ea8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports